<template>
  <label for="toggle_selector">
    <div
      class="border-solid border border-(--main-color) rounded-lg text-base font-bold grid grid-cols-2 gap-2 w-fit m-auto mt-7 p-1">
      <span :class="[defaultClass, { [activeClass]: !isChecked }]">{{ toggles[0] }}</span>
      <span :class="[defaultClass, { [activeClass]: isChecked }]">{{ toggles[1] }}</span>
    </div>
  </label>
  <input
    type="checkbox"
    name="toggle_selector"
    id="toggle_selector"
    class="invisible absolute w-0 h-0"
    v-model="isChecked"
    @change="emitChange" />
</template>
<script lang="ts">
import type { PropType } from "vue";
export default {
  name: "ToggleSelector",
  emits: ["toggleChange"],
  props: {
    toggles: {
      type: Array as PropType<string[]>,
      required: true
    }
  },
  data() {
    return {
      isChecked: false as boolean
    };
  },
  computed: {
    defaultClass() {
      return "px-5 py-3 select-none text-(--main-color)";
    },
    activeClass() {
      return "bg-(--main-color) text-white rounded-sm";
    }
  },
  methods: {
    emitChange() {
      this.$emit("toggleChange", this.isChecked);
    }
  }
};
</script>
